import type { Dayjs } from "dayjs";
import dayjs from "dayjs";

function isOfferValidityDatesValid() {
  return this.test(
    "isOfferValidityDatesValid",
    function (value: (Dayjs | null)[]) {
      if (!value) {
        return false;
      }
      const rpValue: (Dayjs | null)[] = this.parent.redemptionPeriod;
      const doesItEndBefore =
        rpValue[1] instanceof dayjs
          ? rpValue[1]?.isBefore(value[1])
          : dayjs(rpValue[1])?.isBefore(value[1]);

      if (rpValue && doesItEndBefore) {
        const coreTermsKey: "variantsCoreTermsOfSale" | "coreTermsOfSale" =
          this.path.split(".")[0];
        throw this.createError({
          path: `${coreTermsKey}.redemptionPeriod`,
          message:
            "Redemption period has to end after or be equal to validity period"
        });
      }
      return true;
    }
  );
}
export default isOfferValidityDatesValid;
